<template>
  <div class="results origincert">
     <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>原产地证明办理 </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="results-wrap">
      <div class="headtitle">经核准出口商的权利和义务</div>
      <div class="s1">
        <div class="s1Wrap">
          <div class="ql">
            <span>对其出口或者生产的具备相关优惠贸易协定项下原产资格的货物<span>出具原产地声明</span>，用于在缔约方进口时申请享受优惠贸易协定项下优惠关税待遇。</span>
            <div class="box">权利</div>
          </div>
          <div class="yw">
            <ul>
              <li>经核准出口商应当建立完备的货物原产资格文件管理制度，自原产地声明出具之日起<span>3年内</span>保存能充分证明该货物原产资格的所有文件，文件可以以电子或纸质形式保存。</li>
              <li>经核准出口商不是出口货物生产商的，应当在货物备案前取得生产商提供的货物具备原产资格的信息，并确认货物原产资格。</li>
            </ul>
            <div class="box">义务</div>
          </div>
        </div>
      </div>
      <div class="headtitle" style="margin-top:40px">经核准出口商的申请条件</div>
      <div class="s2">
        <div class="s2Wrap">
          <div class="box box1">可以认定为经核准出口商的条件</div>
          <div class="box2">
            <div class="box box21">高级认证企业</div>
            <div class="box box22">
              <div class="box-content">掌握相关优惠贸易协定项下原产地规则</div>
              <div class="box2-content">出具原产地声明的必要能力要求</div>
            </div>
            <div class="box box23">
              <div class="box-content">建立完备的原产资格文件管理制度</div>
              <div class="box2-content">满足后续核查的要求</div>
            </div>
          </div>
        </div>
      </div>
      <div class="s3">
        <div class="s3Wrap">
          <Row :gutter="30" type="flex">
            <Col span="12" class="p1">
              <div class="wrap">
                <div class="subtitle">原产地证书填制要求</div>
                <div class="desc">（一）出口商的名称及地址；</div>
                <div class="desc">（二）生产商的名称及地址，如已知；</div>
                <div class="desc">（三）进口商或收货人的名称及地址；</div>
                <div class="desc">（四）货物描述及该货物的协调制度编码（六位数级别）；</div>
                <div class="desc">（五）原产地证书编号；</div>
                <div class="desc">（六）适用的原产地标准；</div>
                <div class="desc">（七）出口商或生产商的声明；</div>
                <div class="desc">（八）签发机构以其授权签字和公章的方式，证明原产地证书所列货物符合第三章（原产地规则）所有相关要求；</div>
                <div class="desc">（九）第二章第六条（关税差异）所指的 RCEP 原产国；</div>
                <div class="desc">（十）确定交运货物的细节，例如发票号码、始发日期、船只名称或航空器航班号和卸货口岸；</div>
                <div class="desc">（十一）对于适用区域价值成分原产地标准而言，离岸价格；</div>
                <div class="desc">（十二）货物的数量；</div>
                <div class="desc">（十三）对于背对背原产地证书而言，原始原产地证明的编号、签发日期、首次出口缔约方的 RCEP 原产国以及首次出口缔约方经核准出口商的授权码（如适用）。</div>
              </div>
            </Col>
            <Col span="11" class="p2">
              <div class="wrap"><img src="~@/assets/images/oc/3.jpg" alt=""></div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s4">
        <div class="s4Wrap">
          <div class="subtitle">原产地声明填制要求</div>
          <div class="desc">（一）出口商的名称及地址；</div>
          <div class="desc">（二）生产商的名称及地址，如已知；</div>
          <div class="desc">（三）进口商或收货人的名称及地址；</div>
          <div class="desc">（四）货物描述及该货物的协调制度编码（六位数级别）；</div>
          <div class="desc">（五）对于经核准出口商而言，出口商或生产商的授权码或识别码；</div>
          <div class="desc">（六）唯一参考编号；</div>
          <div class="desc">（七）原产地授予标准；（同上）</div>
          <div class="desc">（八）授权签署者关于原产地声明所列货物符合第三章（原产地规则）所有相关要求的认证；</div>
          <div class="desc">（九）第二章第六条（关税差异）所指的 RCEP 原产国；</div>
          <div class="desc">（十）离岸价（FOB 价值），如使用区域价值成分原产地（conferring）标准；</div>
          <div class="desc">（十一）货物的数量；</div>
          <div class="desc">（十二）对于背对背原产地声明而言，原始原产地证明编号、签发日期、首次出口缔约方的 RCEP 原产国以及首次出口缔约方经核准出口商的授权码（如适用）。</div>
        </div>
      </div>
      <ZX></ZX>
    </div>
  </div>
</template>

<script>
import ZX from '@/components/layout/ZX'

export default {
  name: 'OriginCert',
  components: { ZX },
}
</script>

<style scoped>
.results{
  position: relative;
  padding: 15px 0 25px;
}
.results-wrap{
  width:1400px;
  margin: 0 auto;
  padding-bottom: 20px;
  max-width: var(--contentPageMaxWidth);
}
.headtitle{
  font-size: 2.6rem;
  margin-bottom: 10px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 50px;
  color: #333;
  text-align: center;
}
.s1 .ql, .s1 .yw{
  border: 1px solid #0675b5;
  position: relative;
  padding: 35px 20px 30px 75px;
  background: url("~@/assets/images/oc/1.png") 20px 30px no-repeat transparent;
  background-size: 40px;
  min-height: 70px;
  font-size: 14px;
  color: #333;
}
.s1 .ql span{
  text-align: justify;
}
.s1 .ql span span{
  font-weight: bold;
}
.s1 .yw{
  margin-top: 50px;
  padding-left: 90px;
  background-image: url("~@/assets/images/oc/2.png");
}
.s1 ul li{
  margin-top: 5px;
  text-align: justify;
  list-style: disc;
}
.s1 ul li:first-child{
  margin-top: 0;
}
.s1 ul li span{
  color: red;
  font-weight: bold;
}
.s1 .box{
  background-color: #0675b5;
  color: #fff;
  font-size: 16px;
  width: 160px;
  border-radius: 20px;
  text-align: center;
  padding: 2px 0;
  position: absolute;
  left: 20px;
  top: 0;
  transform: translateY(-50%);
}
.s2{
  font-size: 16px;
  font-weight: bold;
  padding-left: 40px;
}
.s2 .s2Wrap{
  display: flex;
  align-items: center;
}
.s2 .box{
  background-color: #0675b5;
  color: #fff;
}
.s2 .box1{
  border-radius: 6px;
  width: 160px;
  padding: 12px;
  text-align: center;
  position: relative;
}
.s2 .box1::after{
  content: "";
  position: absolute;
  height: 1px;
  background-color: #000;
  width: 120px;
  top: 50%;
  transform: translateY(-50%);
  right: -120px;
}
.s2 .box2{
  position: relative;
}
.s2 .box2::before, .s2 .box2::after{
  content: "";
  position: absolute;
  width: 1px;
  height: 80px;
  background-color: #000;
  left: -60px;
}
.s2 .box2::before{
  top: 30px;
}
.s2 .box2::after{
  bottom: 30px;
}
.s2 .box2 .box::before{
  content: "";
  position: absolute;
  width: 1px;
  height: 50%;
  top: 50%;
  background-color: #000;
  left: -60px;
}
.s2 .box2 .box22::before{
  height: 100%;
  top: 0;
}
.s2 .box2 .box23::before{
  top: 0;
}
.s2 .box2 .box::after{
  content: "";
  position: absolute;
  height: 1px;
  background-color: #000;
  width: 60px;
  top: 50%;
  transform: translateY(-50%);
  left: -60px;
}
.s2 .box2{
  margin-left: 120px;
}
.s2 .box2 .box{
  position: relative;
  margin-bottom: 48px;
  padding: 8px 12px;
  text-align: center;
  width: 270px;
}
.s2 .box2 .box:last-child{
  margin-bottom: 0;
}
.s2 .box2-content{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  color: #000;
  right: -84%;
  width: 75%;
  text-align: left;
}
.s3, .s4{
  margin-top: 40px;
  color: #333;
}
.s4{
  margin-bottom: 40px;
}
.s3 .p1{
  padding-top: 5%;
}
.s3 .subtitle, .s4 .subtitle{
  font-size: 16px;
  margin-bottom: 10px;
  padding-left: 10px;
}
.s3 .desc, .s4 .desc{
  margin-bottom: 10px;
  text-align: justify;
  line-height: 26px;
  font-size: 14px;
}
</style>

<style>
@media print,screen and (min-width:2300px) {
  .origincert .headtitle{
    font-size: 3rem;
  }
  .origincert .s2 .box2 .box{
    width: 300px;
  }
  .origincert .s1 .ql, .origincert .s1 .yw{
    font-size: 16px;
  }
  .origincert .s1 .box{
    font-size: 18px;
  }
  .origincert .s2{
    font-size: 18px;
  }
  .origincert .s3 .desc, .origincert .s4 .desc{
    font-size: 16px;
  }
  .origincert .s3 .subtitle, .origincert .s4 .subtitle{
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/OriginCert.vue